import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbCardModule, NbDialogModule, NbMenuModule } from '@nebular/theme';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { GenericCrudModule } from 'app/genericForm/generic-crud.modules';

import { ThemeModule } from '../@theme/theme.module';
import { ModalABMComprobanteComponent } from './modal-abm-comprobante/modal-abm-comprobante.component';
import { ModalBuscadorStockComponent } from './modal-buscador-stock/modal-buscador-stock.component';
import { ModalDecidirPiezaComponent } from './modal-decidir-pieza/modal-decidir-pieza.component';
import { ModalNotificacionesComponent } from "./modal-notifiaciones/modal-notificaciones.component";
import { RenovateSessionComponent } from "./session/renovate-session.component";

@NgModule({
  imports: [
    ThemeModule,
    NbMenuModule,
    NbDialogModule.forChild(),
    GenericCrudModule,
    NbCardModule,
    CommonModule,
    NgbModalModule,
    FormsModule
  ],
  declarations: [
    ModalABMComprobanteComponent,
    ModalBuscadorStockComponent,
    RenovateSessionComponent,
    ModalNotificacionesComponent,
    ModalDecidirPiezaComponent
  ],
  exports: [
    ModalABMComprobanteComponent,
    ModalBuscadorStockComponent,
    RenovateSessionComponent,
    ModalNotificacionesComponent
  ],
  entryComponents: [
    ModalABMComprobanteComponent,
    ModalBuscadorStockComponent,
    RenovateSessionComponent,
    ModalNotificacionesComponent,
    ModalDecidirPiezaComponent
  ],
})
export class WidgetsModule {
}
